/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // SD-6522 update verbiage
  includeBenefitsTitle: {
    id: 'BenefitSelection_IncludeBenefitsTitle',
    defaultMessage: 'Include Benefits',
  },
  includeBenefitsLabel: {
    id: 'BenefitSelection_IncludeBenefitsLabel',
    // SD-6553 - Correcting text for benefit application
    defaultMessage: 'You can include any of the following benefits as part of your application.',
  },
  buttonLabel: {
    id: 'BenefitSelection_ButtonLabel',
    defaultMessage: 'Continue',
  },
  noProgramsSelectedErrorMessage: {
    id: 'BenefitSelection_NoProgramsSelectedErrorMessage',
    defaultMessage: 'Please select at least one benefit to proceed.',
  },
  backlink: {
    id: 'BenefitSelection_Backlink',
    defaultMessage: 'Back',
  },

  //SD-7066 ak - update message verbiage
  selectAll: {
    id: 'selectAll',
    defaultMessage: 'Select all benefits',
  },
  programIcon: {
    id: 'Program_Icon',
    defaultMessage: 'Icon of program',
  },
});
